/**
 *
 * Ask
 *
 */

export const NoteContentModelMixin = {
  name: 'NoteContentModelMixin',

  data: () => {
    return {
      noteContent: '',
    };
  },

  computed: {
    c_isNoteContentBlank() {
      return '' === this.noteContent || '<p><br></p>' === this.noteContent;
    },
  },
};

export default NoteContentModelMixin;
